/**
 * Enumerating all possible states the immobilizer may have.
 *
 * @readonly
 * @enum {string}
 */
export const ObjectImmobilizerStateTypes = Object.freeze({
    BLOCKED: 'BLOCKED',
    BLOCK_PENDING: 'BLOCK_PENDING',
    UNBLOCKED: 'UNBLOCKED',
    UNBLOCK_PENDING: 'UNBLOCK_PENDING'
})

/**
 *
 * @type {Readonly<{UNBLOCK: string, BLOCK: string}>}
 */
export const ObjectImmobilizerUpdateTypes = Object.freeze({
    BLOCK: 'BLOCK',
    UNBLOCK: 'UNBLOCK'
})
